var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.certificates.length)?_c('v-row',{staticClass:"mt-2",class:{ 'justify-center': _vm.$b.m, 'justify-end': _vm.$b.td }},[_c('div',[_c('Footer-Certificates',{attrs:{"items":_vm.certificates}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }